import { PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { projectsAPINEW } from '../../api/projects-api';
import { setAppStatusAC } from '../../app/app-reducer';
import { AppRootState } from '../../app/store';
import { handleRequestResponseError } from '../../utils/errorUtils/handleServerNetworkError';

export type FileType = {
  fileName: string,
  size: number,
  url: string,
  createdDate: any
}

export type NewTaskRelationsTypes = {
  relations: Array<FileType>
  currentAttachmentUrl: string
  currentAttachmentType: string
}

const initialState: NewTaskRelationsTypes = {
  relations: [] as FileType[],
  currentAttachmentUrl: '',
  currentAttachmentType: ''
}

export const addAttachmentToNewTaskTC  = createAsyncThunk('addAttachment/newTask', async (params: {projectName: string, projectId: number, fileName: string,
  size: number, formData: any}, thunkAPI) => {
 thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
 const state = thunkAPI.getState() as AppRootState
 const token = state.auth.token
 try {
   const res = await projectsAPINEW.createAttachment(token, params.projectId, params.projectName, params.fileName, params.formData)
   const url = res.data[0].url
   const date = new Date()
   thunkAPI.dispatch(setNewTaskAttachment({fileName: params.fileName, size: params.size, url: url, date}))
   thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
 } catch (error: any) {
  handleRequestResponseError(error, thunkAPI.dispatch)
   return thunkAPI.rejectWithValue(null)
 }
})

export const OpenNewTaskAttachmentTC = createAsyncThunk('openAddAttachment/newTask', async (params: {
  projectId: number, url:string, fileName: string }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  let arr = params.url.split('/')
  const attachment = arr[arr.length - 1]
  const arr2 = attachment.split('?')
  const attachmentId = arr2[0]
  let arr3 = params.fileName.split('.')
  const type = arr3[arr3.length - 1]
  console.log("open file: TYPE ", type)
  try {
    const res = await projectsAPINEW.getAttachment(token, params.projectId, attachmentId, params.fileName)
    console.log("open file: ", res)
    const url = window.URL.createObjectURL(res.data)
    thunkAPI.dispatch(setCurrentAttachmentNewTask({ url, type }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
})

export const removeAttachmentFromNewTaskTC  = createAsyncThunk('removeAttachment/newTask', async (params: {url: string}, thunkAPI) => {
 thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
 const state = thunkAPI.getState() as AppRootState
 const token = state.auth.token
 try {
  //  const res = await projectsAPINEW.removeAttachment(token, params.projectId, params.projectName, params.fileName, params.formData)
  //  const url = res.data[0].url
  //  const date = new Date()
   thunkAPI.dispatch(removeAttachment({url: params.url}))
   thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
 } catch (error: any) {
  handleRequestResponseError(error, thunkAPI.dispatch)
   return thunkAPI.rejectWithValue(null)
 }
})

const slice = createSlice({
  name: 'workItems',
  initialState: initialState,
  reducers: {
    setNewTaskAttachment(state, action: PayloadAction<{ fileName: string, size: number, url: string, date: any }>) {
      let newAtt: FileType = { fileName: action.payload.fileName, size: action.payload.size, url: action.payload.url, createdDate: action.payload.date }
      state.relations.unshift(newAtt)
    },
    setCurrentAttachmentNewTask(state, action: PayloadAction<{url: string, type: string}>) {
      if(action.payload) {
        state.currentAttachmentUrl = action.payload.url
        state.currentAttachmentType = action.payload.type
     }
    },
    removeAttachment(state, action: PayloadAction<{ url: string }>) {
      const arr = state.relations.filter(att => att.url !== action.payload.url)
      state.relations = arr
    },
    clearAttachmentState(state) {
      state.relations = [] as Array<FileType>
    }
  }
})

export const newTaskAttachmentsReducer = slice.reducer
export const {setNewTaskAttachment , removeAttachment, clearAttachmentState, setCurrentAttachmentNewTask} = slice.actions
